import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';

// Importando os layouts
import AuthLayout from '../pages/_layouts/auth';
import DefaultLayout from '../pages/_layouts/default';
import { store } from '~/store';

export default function RouteWrapper({
  component: Component,
  isPrivate = false,
  isProvider = false,
  isUser = false,
  isDiretor = false,
  ...rest
}) {
  const { signed } = store.getState().auth;

  const Layout = signed ? DefaultLayout : AuthLayout;

  if (!signed && isPrivate) {
    return <Redirect to="/" />;
  }

  if (signed && !isPrivate) {
    return <Redirect to="/dashboard" />;
  }

  if (signed) {
    const { provider } = store.getState().user.profile;

    if (signed && isProvider && provider !== '4') {
      return <Redirect to="/dashboard" />;
    }

    if (signed && isDiretor && provider !== '2' && provider !== '4') {
      return <Redirect to="/dashboard" />;
    }

    if (signed && isUser && provider === '3') {
      return (
        <Route
          {...rest}
          render={props => (
            <Layout>
              <Component {...props} />
            </Layout>
          )}
        />
      );
    }
  }

  return (
    <Route
      {...rest}
      render={props => (
        <Layout>
          <Component {...props} />
        </Layout>
      )}
    />
  );
}

RouteWrapper.propTypes = {
  isPrivate: PropTypes.bool,
  isProvider: PropTypes.bool,
  isUser: PropTypes.bool,
  isDiretor: PropTypes.bool,
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
    .isRequired,
};

RouteWrapper.defaultProps = {
  isPrivate: false,
  isProvider: false,
  isUser: false,
  isDiretor: false,
};
